export default {"src":"/_next/static/media/discover-the-future-of.af08b74c.svg","height":514,"width":821,"blurWidth":0,"blurHeight":0};